import {CommonService} from '../../../services/common.service';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatDialogRef} from '@angular/material/dialog';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
  templateUrl: './accessories-form.component.html'
})

export class AccessoriesFormComponent implements OnInit {
  id: number;
  isActive: number;
  isActiveName: string;
  isModeEdit: boolean;
  material: any;
  manufacturers: any;
  materialAccessories: any;
  materialAccessory: string;
  materialID: string;
  materials: any;
  manufacturerName: any;
  selectedManufacturer: any;
  selectedMaterial: any;
  selectedMaterialAccessory: any;
  title: string;
  value: number;

  constructor(private commonService: CommonService,
              private matDialogRef: MatDialogRef<AccessoriesFormComponent>,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.isModeEdit = this.data.mode === 'edit';
    this.title = this.isModeEdit ? 'Ενημέρωση Κωδικού' : 'Προσθήκη νέου Κωδικού';
    this.material = data.material;
    this.isActiveName = 'Ενεργό';
  }

  public async ngOnInit(): Promise<any> {
    if (this.isModeEdit) {
      this.id = this.material.id;
      this.materialAccessory = this.material.accessory_category_description;
      this.materialID = this.material.material_id;
      this.selectedMaterial = this.material.material_id;
      this.selectedManufacturer = this.material.manufacturer_id;
      this.manufacturerName = this.material.manufacturer_description;
      this.selectedMaterialAccessory = this.material.accessory_category_description;
      this.value = this.material.value;
      this.isActive = this.material.is_active;
      this.isActiveName = this.findActiveName();
    } else {
      this.isActive = 1;
      await this.initMaterials();
      await this.initAccessoryCategories();
      await this.initManufacturers();
    }
  }

  async initAccessoryCategories() {
    try {
      this.materialAccessories = await this.commonService.getList('accessory/case_types');
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async initManufacturers() {
    try {
      this.manufacturers = await this.commonService.getList('manufacturer');
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async initMaterials() {
    try {
      this.materials = await this.commonService.getSimpleList('material?order=id asc');
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  close(material?) {
    this.matDialogRef.close(material);
  }

  isFieldDisabled() {
   return this.isModeEdit;
  }

  isToggleChecked() {
   return !!this.isActive;
  }

  submitMaterialAccessories() {
    const model = {
      id: this.isModeEdit ? this.material.id : null,
      material_id: this.selectedMaterial.id,
      accessory_category_id: this.selectedMaterialAccessory.id,
      manufacturer_id: this.selectedManufacturer.id,
      value: this.value,
      is_active: this.isActive
    };
    this.close(model);
  }

  toggleChanged(event: any) {
    const newValue = event.checked ? 1 : 0;
    this.isActive = newValue;
    this.isActiveName = this.findActiveName();
    return newValue;
  }

  formInvalid(): boolean {
    // return false;
    return !this.selectedMaterialAccessory || !this.selectedMaterial || !this.value;
  }

  private findActiveName() {
    return this.isActive ? 'Ενεργό' : 'Ανενεργό';
  }
}
